export class NiveisTurmas {
	id: number;
	codigo: string;
	descricao: string;
	usuarioAlteracao: number;
}
